'use client'

import { createContext, type ReactNode, useId } from 'react'

interface Props {
  name: string
  id?: string
  children?: ReactNode
  hidden?: Record<string, string | number>
}

export const FormObjectContext = createContext<string | null>(null)

export function FormObject({ name, id: externalId, children, hidden }: Props) {
  const generatedId = useId()
  const id = externalId ?? generatedId

  return (
    <FormObjectContext value={`${name}[${id}]`}>
      <input type="hidden" name={name} value={id} />
      {hidden &&
        Object.entries(hidden).map(([fieldName, value]) => (
          <input
            key={fieldName}
            type="hidden"
            name={`${name}[${id}][${fieldName}]`}
            value={value}
          />
        ))}
      {children}
    </FormObjectContext>
  )
}
